import type { State } from '../types';
import isNil from 'lodash/isNil';
/**
 * Checking if the latest values of the recurring bill estimation is fetched and using store
 * to identify if the grand total is not undefined.
 * e.g. For free products as well the grandTotal will be a number i.e. 0
 * @param recurringBillEstimate
 */
export function getIsLatestBillEstimationFetched({
  recurringBillEstimate,
}: {
  recurringBillEstimate?: State['recurringBillEstimate'];
}) {
  return !isNil(recurringBillEstimate?.partnerPricing?.grandTotal);
}
